import React from "react";
import ReactTooltip from 'react-tooltip';
import { Link } from "react-router-dom";
import { ReactComponent as IconLeft } from "assets/images/icons/project-icons/arrow_back.svg"
import { ReactComponent as IconLeftLight } from "assets/images/icons/project-icons/arrow_back_light.svg"

import useUrlNavigation from "hooks/useUrlNavigation";

const Pagination = (props) => {
    const {urlQuery} = useUrlNavigation();
    const {data, limit: propsLimit} = props;

    
    let hasPrevPage, prevPage;
    let hasNextPage, nextPage;
    let page, limit, totalDocs, totalPages;


    if (data){
        if (data?.page && data?.limit && data?.totalDocs && data?.totalPages){
            page = data?.page;
            limit = data?.limit;
            totalDocs = data?.totalDocs;
            totalPages = data?.totalPages;

            if (typeof data.hasNextPage !== 'undefined'){
                hasNextPage = data.hasNextPage;
            }
            if (typeof data.nextPage !== 'undefined'){
                nextPage = data.nextPage;
            }

            if (typeof data.hasPrevPage !== 'undefined'){
                hasPrevPage = data.hasPrevPage;
            }
            else if (typeof data.hasPreviousPage !== 'undefined'){
                hasPrevPage = data.hasPreviousPage;
            }
        
            if (typeof data.previousPage !== 'undefined'){
                prevPage = data.previousPage;
            }
            else if (typeof data.prevPage !== 'undefined'){
                prevPage = data.prevPage;
            }
        }
        else if (data?.currentPage && data?.perPage && data?.total && data?.totalPages){
            page = parseInt(data?.currentPage) || 0;
            limit = parseInt(data?.perPage) || 0;
            totalDocs = parseInt(data?.total) || 0;
            totalPages = parseInt(data?.totalPages) || 0;
            hasNextPage = page < totalPages ? true : false;
            nextPage = page + 1;
            hasPrevPage = page > 1 ? true : false;
            prevPage = page - 1;
        }
        else{
            page = parseInt(data?.page) || 0;
            limit = parseInt(propsLimit) || 0;
            totalDocs = parseInt(data?.total) || 0;

            totalPages = Math.ceil(totalDocs / limit);

            hasNextPage = page < totalPages ? true : false;
            nextPage = page + 1;
            hasPrevPage = page > 1 ? true : false;
            prevPage = page - 1;
        }
    }
    else{
        page = 1;
        limit = 20;
        totalDocs = 50;
        totalPages = Math.ceil(totalDocs / limit);
        hasNextPage = page < totalPages ? true : false;
        nextPage = page + 1;
        hasPrevPage = page > 1 ? true : false;
        prevPage = page - 1;
    }

    
    // const startIndex = ((page-1) * limit) + 1;
    // const lastIndex = ((page * limit) <= totalDocs)? (page * limit) : totalDocs;


    // console.log("page", page);
    // console.log("limit", limit);
    // console.log("totalDocs", totalDocs);
    // console.log("totalPages", totalPages);
    // console.log("hasNextPage", hasNextPage);
    // console.log("nextPage", nextPage);
    // console.log("hasPrevPage", hasPrevPage);
    // console.log("prevPage", prevPage);


    return (

        <>
            <ReactTooltip />

            <div className="py-4 px-4 text-sm">

                {/* <div className="hidden my-auto md:block mb-2 xl:mb-0">
                    Showing {startIndex} - {lastIndex} {pluralize(lastIndex, "item", "items")} out of {totalDocs} {pluralize(totalDocs, "result", "results")} found
                </div> */}

                <div className="my-auto w-full">
                    <div className="flex w-full">
                        <div className="hidden mr-4 my-auto">
                            {page} of {totalPages}
                        </div>

                        <div className="pagination w-full flex items-center justify-between">
                            
                            <div>
                                {(hasPrevPage) && 
                                    <Link to={urlQuery("page=" + prevPage)}
                                        className="flex items-center border border-[#e5e7eb] rounded-lg shadow-sm p-2 pl-3">
                                        &nbsp;<IconLeft width={13} />
                                        <span className="text-sm ml-1">Previous</span>
                                    </Link>
                                }
                                {(!hasPrevPage) && 
                                    <div
                                        className="flex items-center border border-[#e5e7eb] rounded-lg p-2 pl-3 cursor-not-allowed">
                                        &nbsp;<IconLeftLight width={13} />
                                        <span className="text-sm ml-1 text-gray-300">Previous</span>
                                    </div>
                                }
                            </div>

                            <div className="flex items-center space-x-6">
                                
                                {((page !== 1) && (page - 3) >= 1) &&
                                    <Link to={urlQuery("page=1")} className="pagination-items-number">
                                        <div>
                                            1
                                        </div>
                                    </Link>
                                }

                                {((page - 3) > 1) &&
                                    <div className="pagination-items-null">
                                        <div>
                                            ...
                                        </div>
                                    </div>
                                }
                                
                                {((page - 2) >= 1) &&
                                    <Link to={urlQuery("page=" + (page - 2))} className="pagination-items-number hidden sm:flex">
                                        <div>
                                            {page - 2}
                                        </div>
                                    </Link>
                                }
                                
                                {((page - 1) >= 1) &&
                                    <Link to={urlQuery("page=" + (page - 1))} className="pagination-items-number hidden sm:flex">
                                        <div>
                                            {page - 1}
                                        </div>
                                    </Link>
                                }
                                


                                <Link to={urlQuery("page=" + page)} className="pagination-items-number pagination-items-active">
                                    <div>
                                        {page}
                                    </div>
                                </Link>


                                {((page + 1) <= totalPages) &&
                                    // <Link to={urlQuery("page=" + (page + 1))} className="pagination-items-number hidden sm:flex md:hidden lg:flex">
                                    <Link to={urlQuery("page=" + (page + 1))} className="pagination-items-number hidden sm:flex">
                                        <div>
                                            {page + 1}
                                        </div>
                                    </Link>
                                }

                                {((page + 2) <= totalPages) &&
                                    <Link to={urlQuery("page=" + (page + 2))} className="pagination-items-number hidden sm:flex">
                                        <div>
                                            {page + 2}
                                        </div>
                                    </Link>
                                }

                                {((page + 3) < totalPages) &&
                                    <div className="pagination-items-null">
                                        <div>
                                            ...
                                        </div>
                                    </div>
                                }
                                
                                {(page !== totalPages) && ((page + 2) < totalPages) &&
                                    <Link to={urlQuery("page=" + (totalPages))} className="pagination-items-number">
                                        <div>
                                            {totalPages}
                                        </div>
                                    </Link>
                                }
                            </div>
                            
                            
                            <div>
                                {(hasNextPage) && 
                                    <Link to={urlQuery("page=" + nextPage)} 
                                        className="flex items-center border border-[#e5e7eb] rounded-lg shadow-sm p-2 pr-3">
                                        <span className="text-sm mr-1">Next</span>
                                        &nbsp;<IconLeft width={13} className="rotate-180" />
                                    </Link>
                                }
                                {(!hasNextPage) && 
                                    <div
                                        className="flex items-center border border-[#e5e7eb] rounded-lg p-2 pr-3 cursor-not-allowed">
                                        <span className="text-sm mr-1 text-gray-300">Next</span>
                                        &nbsp;<IconLeftLight width={13} className="rotate-180"/>
                                    </div>
                                }
                            </div>
                            
                        </div>

                    </div>
                </div>

            </div>
        </>
    );
};

export default Pagination;